'use client'

import useCurrentTime from '@/hooks/use-current-time'
import { useEffect, useState } from 'react'

export const TimeDisplay = () => {
  const time = useCurrentTime()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return <time>--:--</time>
  }

  return (
    <time>
      {' '}
      {time.hours}
      <span className="blink-colon">:</span>
      {time.minutes}
      {time.amPm}
    </time>
  )
}
